<div>
  <abcButton
    #addRowButton
    [id]="'buttonAdd'"
    [image]="'assets/images/Neu_128x128-32.png'"
    [class]="'properties-button'"
  >
  </abcButton>
  <abcButton
    #saveRowButton
    [id]="'buttonSave'"
    [image]="'assets/images/save.svg'"
    [class]="'properties-button'"
  ></abcButton>
  <abcButton
    #exitButton
    [id]="'buttonExit'"
    [class]="'properties-button'"
    [image]="'assets/images/GroupPanelVisibilityLarge.png'"
    matTooltip="res('PropertiesEditorDetails-GroupingField')"
  >
  </abcButton>
</div>
<div #abcGridContainer></div>
